import React from 'react';
import {createMuiTheme} from '@material-ui/core/styles';

import SMgreen from './colors/sm-green';

const theme = createMuiTheme({
    palette: {
	primary: SMgreen,
	type: 'dark', // Switching the dark mode on is a single property value change.
    },
    overrides: {
	MuiAppBar: {
	    root: {
		border: 'none'
	    }
	}
    }
});

export default theme;



// WEBPACK FOOTER //
// ./src/components/theme/index.jsx